module.exports = __webpack_public_path__ + "static/media/searchIcon.1ec71d6d.svg";